<nb-card>
  <nb-card-header class="d-flex align-items-center">
    <b *ngIf="ticket">
      Task nr: {{ticket.id}}
    </b>
    <b *ngIf="!ticket">
      Task nou
    </b>
    <button class="ml-auto" nbButton status="danger" (click)="dismiss()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <form [formGroup]="form" class="form">
      <div class="formItem mb-3">
        <label class="label" for="title">Titlu</label>
        <input fullWidth nbInput id="title" formControlName="title" placeholder="Titlu task (max 100 caractere)" maxlength="100">
      </div>
      <div class="formItem">
        <label class="label" for="description">Descriere</label>
        <textarea class="max100" nbInput id="description" formControlName="description" rows="12"></textarea>
      </div>
      <div class="row">
        <div class="col-3">
          <label class="label" for="type">Tip</label>
          <nb-select class="max100 p-0" placeholder="Tip" formControlName="type"
            [selected]="form?.controls?.type?.value">
            <nb-option *ngFor="let supportTicketTypeKey of supportTicketTypeKeys" [value]="supportTicketTypeKey">
              {{ supportTicketTypeObject[supportTicketTypeKey] }}
            </nb-option>
          </nb-select>
        </div>
        <div class="col-3">
          <label class="label" for="urgency">Importanță</label>
          <nb-select class="max100 p-0" placeholder="Importanță" formControlName="urgency"
            [selected]="form?.controls?.urgency?.value">
            <nb-option *ngFor="let supportTicketUrgencyKey of supportTicketUrgencyKeys" [value]="supportTicketUrgencyKey">
              {{ supportTicketUrgencyObject[supportTicketUrgencyKey] }}
            </nb-option>
          </nb-select>
        </div>
        <div class="col-3">
          <label class="label" for="status">Stare</label>
          <nb-select class="max100 p-0" placeholder="Stare" formControlName="status"
            [selected]="form?.controls?.status?.value">
            <nb-option *ngFor="let supportTicketStatusKey of supportTicketStatusKeys" [value]="supportTicketStatusKey">
              {{ supportTicketStatusObject[supportTicketStatusKey] }}
            </nb-option>
          </nb-select>
        </div>
        <div class="col-3">
          <label class="label" for="priority">Prioritatea</label>
          <input nbInput type="number" fullWidth="" formControlName="priority"/>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <label class="label" for="estimation">Estimare</label>
          <input nbInput fullWidth="" formControlName="estimation"/>
        </div>
        <div class="col-3">
          <label class="label" for="deadline">Termen limită</label>
          <input nbInput placeholder="Termen limită" class="col-12" [nbDatepicker]="deadlinePicker" formControlName="deadline" fullWidth>
            <nb-datepicker #deadlinePicker [min]="ticketDate"></nb-datepicker>
        </div>
        <div class="col-3">
          <label class="label" for="assignee">Responsabil</label>
          <nb-select class="max100 p-0" formControlName="assignee">
            <nb-option-group *ngFor="let team of teams" [title]="team.description">
              <nb-option *ngFor="let member of team.members" [value]="member.user_id">{{ member.fullname }}</nb-option>
            </nb-option-group>
          </nb-select>
        </div>
        <div class="col-3">
          <label class="label" for="testedBy">Testat de</label>
          <nb-select class="max100 p-0" formControlName="testedBy" placeholder="Selectează">
            <nb-option-group *ngFor="let team of teams" [title]="team.description">
              <nb-option *ngFor="let member of team.members" [value]="member.user_id">{{ member.fullname }}</nb-option>
            </nb-option-group>
          </nb-select>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-3">
          <label class="label">Client</label>
          <ngx-autocomplete-input [items]="clients" [addTag]="false" [initialValue]="selectedClient"
            (itemSelected)="onClientSelected($event)" placeholder="Caută client" class="d-block">
          </ngx-autocomplete-input>
        </div>
        <div class="col-3">
          <label class="label" for="version">Versiune</label>
          <input nbInput fullWidth id="version" formControlName="version" placeholder="Versiune"/>
        </div>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer class="d-flex">
   <button class="ml-auto" nbButton status="primary" (click)="saveSupportTicket()">Salvează</button>
  </nb-card-footer>
</nb-card>
